<template>
    <div class="game-sections">
        <div class="sections-wrapper">
        <SectionButton
        v-for="(item,index) in actualView.sections"
        :key="index"
        :sectionItem = item
        :numberItem = index
        @openSection = openSection($event)
        />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'
import SectionButton from '@/components/game/SectionButton.vue'

export default {
    name: "GameSections",
    components: {
        SectionButton
    },
    computed: {
      ...mapGetters([
          "actualView",
      ])       
    },
    methods: {
        ...mapActions([
          "setActualView",
          "setViewedSection",
        ]),
        openSection(numberSection){
            this.setActualView(this.actualView.sections[numberSection].sectionContent)
            this.setViewedSection(numberSection)
        }
    },
}
</script>

<style>
    
</style>